// extracted by mini-css-extract-plugin
export default {"modal":"ulBpF","modal-header":"dJe3m","modal-footer":"iJl4u"};